/**
Author - Brijesh Pandey
Git - https://bitbucket.org/__brijesh/
**/

import Error from "./Error";

export default Error;
